import React from "react";
import VideoPlayerPopup from "./VideoPlayerPopup";

const VideoPlayer = ({ videoInfo }) => {
  return (
    <>
      <div className="col-lg-6 col-md-6 col-12" >
        <div className="e-school-environment-single">
          <div className="e-school-env-img">
            <img src={videoInfo?.thumbnail} alt="#" />

            <VideoPlayerPopup
              videoURL={videoInfo?.videoURL}
              className="video"
            />
          </div>

          <div className="e-school-env-content">
            <h4 className="e-school-env-cont-tag">{videoInfo?.sort_title}</h4>
            <h3 className="e-school-env-cont-title">{videoInfo?.heading}</h3>
          </div>
        </div>
      </div>
    </>
  );
};

export default VideoPlayer;
